export class IndexAllocation {
	private allocation: string = "";
	private asset_id: string = "";
	private balance: string = "0";
	private allocation_percentage: string = "";

	public getAllocation(): string {
		return this.allocation;
	}

	public setAllocation(allocation: string): void {
		this.allocation = allocation;
	}

	public getAssetId(): string {
		return this.asset_id;
	}

	public setAssetId(id: string): void {
		this.asset_id = id;
	}

	public getBalance(): string {
		return this.balance;
	}

	public setBalance(balance: string): void {
		this.balance = balance;
	}

	public getAllocationPercent(): string {
		return this.allocation_percentage;
	}

	public setAllocationPercent(percent: string): void {
		this.allocation_percentage = percent;
	}
}
